export const repairOrderApiNm = {
  getRepairOrder: "/repair-order/getRepairOrder",
  getRepairOrderDetail: "/repair-order/getRepairOrderDetail",
  generateRONo: "/repair-order/generateRONo",
  insertRepairOrder: "/repair-order/insertRepairOrder",
  updateRepairOrder: "/repair-order/updateRepairOrder",
  deleteRepairOrder: "/repair-order/deleteRepairOrder",
  uploadFile: "/repair-order/uploadFile",
  deleteFile: "/repair-order/deleteFile",
}

export const repairOrderColNm = {
  RONo: "เลขที่แจ้งซ่อม",
  ROTm: "เวลาแจ้งซ่อม",
  ROStsId: "สถานะการซ่อม",
  ROStsNm: "สถานะการซ่อม",
  DrvId: "พนักงานขับรถ",
  DrvNNm: "พนักงานขับรถ",
  FLNNm:  "พนักงานขับรถ",
  TukId: "เลขรถ",
  TukCd: "เลขรถ",
  OrdHdr: "หัวข้อแจ้งซ่อม",
  OrdDscp: "รายละเอียดแจ้งซ่อม",
  ReprDscp: "รายละเอียดการซ่อม",
  ReprNNm: "ผู้ซ่อม",
  ReprId: "ผู้ดำเนินการซ่อม",
  ReprOthNm: "ระบุเอง",
  StDte: "วันที่เริ่มซ่อม",
  EstFinDte: "วันที่คาดว่าเสร็จ",
  FinDte: "วันที่เสร็จ",
}

/**
 * ผู้ดำเนินการซ่อม combo: employees and suppliers in one grouped list.
 * AccId and SupId are separate sequences and collide, so the combo ids are
 * namespaced ("A:12" / "S:12") and split back into ReprAccId / ReprSupId on save.
 */
export const getReprCombo = (msData) => [
  ...(msData.accountCombo || []).map(item => ({ ...item, id: `A:${item.id}`, group: "พนักงาน" })),
  ...(msData.supplierCombo || []).map(item => ({ ...item, id: `S:${item.id}`, group: "ผู้จำหน่าย" })),
]

/** ReprAccId / ReprSupId -> the namespaced combo id (null when neither is set) */
export const toReprComboId = (data) =>
  data.ReprAccId ? `A:${data.ReprAccId}` : data.ReprSupId ? `S:${data.ReprSupId}` : null

/** namespaced combo id -> the pair of columns, with the unused one cleared */
export const fromReprComboId = (id) => ({
  ReprAccId: id && id.startsWith("A:") ? +id.slice(2) : null,
  ReprSupId: id && id.startsWith("S:") ? +id.slice(2) : null,
})